import React from 'react';
import { Layout } from 'antd';
import DecompositionResidualUC2Graph from '../components/Graphs/DecompositionResidualUC2Graph';
import '../css/Decomposition.css';

const { Content } = Layout;

const UC2 = () => {
  return (
    <Layout style={{ padding: '24px', minHeight: '100vh', background: '#f0f2f5' }}>
      <Content>
        <div className="decomposition-grid">
          <DecompositionResidualUC2Graph />
        </div>
      </Content>
    </Layout>
  );
};

export default UC2;
